import { render, staticRenderFns } from "./GameDetailView.vue?vue&type=template&id=6046409b&scoped=true"
import script from "./GameDetailView.vue?vue&type=script&lang=js"
export * from "./GameDetailView.vue?vue&type=script&lang=js"
import style0 from "./GameDetailView.vue?vue&type=style&index=0&id=6046409b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046409b",
  null
  
)

export default component.exports